export default [
  { label: 'ALABAMA', value: 'AL' },
  { label: 'ALASKA', value: 'AK' },
  { label: 'ARIZONA', value: 'AZ' },
  { label: 'ARKANSAS', value: 'AR' },
  { label: 'CALIFORNIA', value: 'CA' },
  { label: 'COLORADO', value: 'CO' },
  { label: 'CONNECTICUT', value: 'CT' },
  { label: 'DELAWARE', value: 'DE' },
  { label: 'DISTRICT OF COLUMBIA', value: 'DC' },
  { label: 'FLORIDA', value: 'FL' },
  { label: 'GEORGIA', value: 'GA' },
  { label: 'HAWAII', value: 'HI' },
  { label: 'IDAHO', value: 'ID' },
  { label: 'ILLINOIS', value: 'IL' },
  { label: 'INDIANA', value: 'IN' },
  { label: 'IOWA', value: 'IA' },
  { label: 'KANSAS', value: 'KS' },
  { label: 'KENTUCKY', value: 'KY' },
  { label: 'LOUISIANA', value: 'LA' },
  { label: 'MAINE', value: 'ME' },
  { label: 'MARYLAND', value: 'MD' },
  { label: 'MASSACHUSETTS', value: 'MA' },
  { label: 'MICHIGAN', value: 'MI' },
  { label: 'MINNESOTA', value: 'MN' },
  { label: 'MISSISSIPPI', value: 'MS' },
  { label: 'MISSOURI', value: 'MO' },
  { label: 'MONTANA', value: 'MT' },
  { label: 'NEBRASKA', value: 'NE' },
  { label: 'NEVADA', value: 'NV' },
  { label: 'NEW HAMPSHIRE', value: 'NH' },
  { label: 'NEW JERSEY', value: 'NJ' },
  { label: 'NEW MEXICO', value: 'NM' },
  { label: 'NEW YORK', value: 'NY' },
  { label: 'NORTH CAROLINA', value: 'NC' },
  { label: 'NORTH DAKOTA', value: 'ND' },
  { label: 'OHIO', value: 'OH' },
  { label: 'OKLAHOMA', value: 'OK' },
  { label: 'OREGON', value: 'OR' },
  { label: 'PENNSYLVANIA', value: 'PA' },
  { label: 'RHODE ISLAND', value: 'RI' },
  { label: 'SOUTH CAROLINA', value: 'SC' },
  { label: 'SOUTH DAKOTA', value: 'SD' },
  { label: 'TENNESSEE', value: 'TN' },
  { label: 'TEXAS', value: 'TX' },
  { label: 'UTAH', value: 'UT' },
  { label: 'VERMONT', value: 'VT' },
  { label: 'VIRGINIA', value: 'VA' },
  { label: 'WASHINGTON', value: 'WA' },
  { label: 'WEST VIRGINIA', value: 'WV' },
  { label: 'WISCONSIN', value: 'WI' },
  { label: 'WYOMING', value: 'WY' },
  { label: 'AMERICAN SAMOA', value: 'AS' },
  { label: 'GUAM', value: 'GU' },
  { label: 'NORTHERN MARIANA ISLANDS', value: 'MP' },
  { label: 'PUERTO RICO', value: 'PR' },
  { label: 'VIRGIN ISLANDS', value: 'VI' },
  { label: 'WAKE ISLAND', value: 'WK' },
  { label: 'ARMED FORCES AMERICA', value: 'AA' },
  { label: 'ARMED FORCES EUROPE', value: 'AE' },
  { label: 'ARMED FORCES PACIFIC', value: 'AP' },

  { label: 'ALBERTA', value: 'AB' },
  { label: 'BRITISH COLUMBIA', value: 'BC' },
  { label: 'MANITOBA', value: 'MB' },
  { label: 'NEW BRUNSWICK', value: 'NB' },
  { label: 'NEWFOUNDLAND AND LABRADOR', value: 'NF' },
  { label: 'NOVA SCOTIA', value: 'NS' },
  { label: 'NORTHWEST TERROTORIES', value: 'NT' },
  { label: 'NUNAVUT', value: 'NU' },
  { label: 'ONTARIO', value: 'ON' },
  { label: 'PRINCE EDWARD ISLAND', value: 'PE' },
  { label: 'QUEBEC', value: 'QC' },
  { label: 'SASKATCHEWAN', value: 'SK' },
  { label: 'YUKON TERRITORY', value: 'YT' },
  { label: 'MEXICO', value: 'MX' },
  { label: 'MARSHALL ISLANDS', value: 'MH' },
  { label: 'FEDERATED STATES OF MICRONESIA', value: 'FM' },
  { label: 'PALAU', value: 'PW' },
  { label: 'OTHER', value: 'ZZ' },
];
